<template>
  <div class="index">
      <div class="indexBanner">
        <div class="imgbox">
          <div class="imgBoxCenter">
            <el-carousel trigger="click" height="594px">
              <el-carousel-item v-for="(item,index) in bannerList" :key="index">
                  <img v-if="item.linkId" style="cursor:pointer" :src="item.pic" @click="bannerLinkTo(item)" alt="TINDOE坦途"/>
                  <img v-else :src="item.pic" alt="TINDOE坦途"/>
              </el-carousel-item>
            </el-carousel>
          </div>
          <!--<div class="moreBtn"></div>-->
        </div>
      </div>
    <div class="className">
        <div class="titleBox">活动分类</div>
        <ul>
          <li v-for="(item,index) in activitiesList" :key="index">
            <router-link :to="'/activetys/'+item.id">
            <img :src="item.pic" alt="TINDOE坦途"/>
            <p class="namebox">
              <span class="icon"></span>
              {{item.name}}
            </p>
            </router-link>
          </li>
        </ul>
      <div class="checkMore"><router-link to="/activetys">查看更多</router-link></div>
    </div>
    <div class="topLocation">
      <div class="topLocationM">
        <div class="titleBox">热门地点</div>
        <ul>
          <li v-for="(item,index) in hotPlaceList" :key="index">
            <router-link :to="'/activitieDetails/'+item.id">
            <div class="imgbox"><img :src="item.pic" alt="TINDOE坦途"/></div>
            <div class="name">{{item.name}}</div>
            <div class="desc">{{item.intro}}</div>
            </router-link>
          </li>
        </ul>
        <div class="checkMore" style="margin-top: 45px"><router-link to="/activetys">查看更多</router-link></div>
      </div>
    </div>
    <div class="className product">
      <div class="titleBox">商品分类</div>
      <ul>
        <li v-for="(item,index) in proDuctClassList" :key="index">
          <router-link :to="'/products/'+item.id">
          <img :src="item.pic" alt="TINDOE坦途"/>
          <p class="namebox">
            <span class="icon"></span>
            {{item.name}}
          </p>
          <!--<p class="pricebox">￥56起</p>-->
          </router-link>
        </li>
      </ul>
      <div class="checkMore"><router-link to="/products">查看更多</router-link></div>
    </div>
    <div class="topLocation tourism" style="height: 1300px;">
      <div class="topLocationM">
        <div class="titleBox">推荐商品</div>
        <ul>
          <li v-for="(item,index) in recommendGoods" :key="index" style="margin-bottom: 20px;">
            <router-link :to="'/productDetails/'+item.id">
              <div class="imgbox"><img :src="item.pic" alt="TINDOE坦途"/></div>
              <div class="name">{{item.name}}</div>
              <div class="price"><span style="font-size: 18px;margin-right: 4px">¥</span>{{item.price.toFixed(2)}}</div>
            </router-link>
          </li>
        </ul>
        <div class="checkMore" style="margin-top: 45px"><router-link to="/products">查看更多</router-link></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        bannerList:[],  //banner图
        activitiesList:[], //活动分类
        hotPlaceList:[],   //热门地点
        proDuctClassList:[], //商品分类
        recommendGoods:[]    //推荐商品
      }
    },
    mounted(){
      this.loadBannerData()
      this.loadActivitiesData()
      this.loadHotPlace()
      this.loadProductClass()
      this.recommendTourismList()
    },
    methods:{
      //点击banner图跳转
      bannerLinkTo(item){
        if(item.linkId){
          let url = '';
          if(item.type == 1){
            url = '/activitieDetails/'+item.linkId;
          }else{
            url = '/productDetails/'+item.linkId;
          }
          const { href } = this.$router.resolve({
             path: url
          });
          window.open(href, '_blank');
        }
      },
      //获取banner数据
      loadBannerData(){
        this.$https.get('/api/banner').then((response)=>{
          this.bannerList = response.data
        });
      },
      //获取活动分类数据
      loadActivitiesData(){
        this.$https.get('/api/travelType').then((response)=>{
          if(response.data.length > 6){
            this.activitiesList = response.data.slice(0,6)
          }else{
            this.activitiesList = response.data
          }
        });
      },
      //获取热门地点数据
      loadHotPlace(){
        this.$https.get('/api/travel/count/8').then((response)=>{
            this.hotPlaceList = response.data
        }).catch((error) => {

        });
      },

      //获取商品分类模块
      loadProductClass(){
        this.$https.get('/api/category').then((response)=>{
          if(response.data.length > 6){
            this.proDuctClassList = response.data.slice(0,6)
          }else{
            this.proDuctClassList = response.data
          }
        });
      },
      //推荐商品
      recommendTourismList(){
        this.$https.get('/api/goods/recommend/count/8').then((response)=>{
          this.recommendGoods = response.data
        });
      }
    }
  }
</script>

<style scoped>
  .indexBanner{
    height: 594px;
    overflow: hidden;
    position: relative;

  }
  .indexBanner .imgbox{
    width: 100%;
    height: 594px;
    overflow: hidden;
    position:relative;
  }
  .indexBanner .imgbox .imgBoxCenter{
      width: 1920px;
      height: 943px;
      position: absolute;
      top: 0px;
      left: 50%;
      margin-left: -960px;
  }
  .indexBanner .imgbox img{
    width: 100%;
    height: 100%;
    display: block;
  }
  .indexBanner .moreBtn{
    width: 374px;
    height: 94px;
    position: absolute;
    top: 620px;
    left: 50%;
    margin-left: -187px;
    background: url("../assets/images/bannercheckmore.png") no-repeat;
    text-indent: -9999px;
    cursor: pointer;
  }
  .className{
    padding-top: 105px;
    width: 1200px;
    margin: 0 auto;
  }
  .className .titleBox{
    width: 273px;
    height: 95px;
    background: url("../assets/images/className.png") no-repeat;
    margin: 0 auto;
    text-indent: -9999px;
  }
  .className.product{
    padding-top: 63px;
  }
  .className.product .titleBox{
    width: 612px;
    height: 117px;
    background: url("../assets/images/produtctclass.png") no-repeat;
  }
  .checkMore{
    width: 280px;
    height: 48px;
    border-radius: 48px;
    text-align: center;
    line-height: 48px;
    /*background: #5680f9;*/
    color: #adadad;
    font-size: 24px;
    margin: 30px auto 50px;
    cursor: pointer;
  }
  .checkMore a{
    color: #adadad;
    background: url("../assets/images/indexMoreBtn.png") no-repeat right center;
    padding-right: 20px;
    text-decoration: none;
  }
  .className ul{
    width: 1220px;
    margin-left: -20px;
    overflow: hidden;
    padding-top: 57px;
  }
  .className ul li{
    float: left;
    width: 386px;
    height: 176px;
    margin: 0 0 20px 20px;
    position: relative;
  }
  .className ul li img{
    display: block;
    width: 100%;
    height: 100%;
  }
  .className ul li .namebox{
    height: 42px;
    line-height: 42px;
    padding-left: 12px;
    position: absolute;
    top: 8px;
    right: 10px;
    font-size: 24px;
    color: #ffffff;
  }
  .className.product ul li{
    height: 386px;
  }
  .className.product ul li  .pricebox{
    height: 42px;
    line-height: 42px;
    position: absolute;
    top: 63px;
    left: 344px;
    font-size: 30px;
    color: #ffcd30;
    font-weight: bold;
  }
  .className ul li .namebox span{
    display: block;
    width: 4px;
    height: 22px;
    position: absolute;
    left: 0px;
    top: 10px;
    background: #ffffff;
  }
  .topLocation{
    background: #fafafa;
    height: 1030px;
  }
  .topLocationM{
    width: 1200px;
    padding-top: 105px;
    margin: 0 auto;
  }
  .topLocationM .titleBox{
    width: 352px;
    height: 96px;
    background: url("../assets/images/topLocation.png") no-repeat;
    margin: 0 auto;
    text-indent: -9999px;
  }
  .topLocation.tourism .titleBox{
    width: 708px;
    height: 107px;
    background: url("../assets/images/tourism.png") no-repeat;
  }
  .topLocationM ul{
    overflow: hidden;
    margin-left: -20px;
    padding-top: 62px;
    width: 1220px;
     padding-bottom: 5px;
  }
  .topLocationM ul li{
    float: left;
    width: 285px;
    height: 290px;
    background: #ffffff;
    margin-left: 20px;
    margin-bottom: 20px;
    box-shadow:0px 2px 4px 0px rgba(0,0,0,0.05);
  }
  .topLocation.tourism li{
    height:410px
  }
  .topLocationM ul li .imgbox{
    width: 285px;
    height: 153px;
  }
  .topLocation.tourism .imgbox{
    height: 285px;
  }
  .topLocationM ul li .imgbox img{
    width: 100%;
    height: 100%;
  }
  .topLocationM ul li .name{
    padding:15px 12px 0px;
    height:42px;
    line-height:21px;
    margin-bottom:15px;
    font-size: 16px;
    color: #5680f9;
    overflow: hidden;
  }
  .topLocation.tourism .name{
    padding: 15px 12px 0px;
    height: 42px;
    line-height: 21px;
    margin-bottom: 15px;
    font-size: 16px;
    color: #5680f9;
    overflow: hidden;
  }
  .topLocation.tourism .price{
    height: 53px;
    line-height: 35px;
    font-size: 32px;
    color: #ffcd30;
    text-align: center;
  }
  .topLocationM ul li .desc{
    padding: 0 20px;
    line-height: 21px;
    max-height: 42px;
    overflow: hidden;
    font-size: 14px;
    color: #999999;
  }
  .el-carousel--horizontal{
    overflow-x: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/index.vue